document.addEventListener('DOMContentLoaded', () => {

  function updateProgressBarUI(cartData) {
    const htmlElement = document.documentElement;
    const inputCountry = document.querySelector('.md-modal__formContent__select button');
    const selectedCountry = inputCountry.getAttribute('data-value');
    const free_shipping_rate = htmlElement.getAttribute('free-shipping-rate');

    let freeShippingValue = free_shipping_rate;

    if (!freeShippingValue) {
      console.warn(`No se encontró una tarifa de envío gratuita para el país: ${selectedCountry}. Usando valor predeterminado.`);
      freeShippingValue = 10900;
    }

    const cartTotal = cartData.total_price;
    const freeShippingLeft = freeShippingValue - cartTotal;
    const freeShippingProgress = (cartTotal / freeShippingValue) * 100;
    const progressBar = document.querySelector('.fcb-progress-bar__bar');
    if (freeShippingProgress > 100 && parseFloat(progressBar.style.width) > 100) {
      return;
    }
    progressBar.style.width = `${freeShippingProgress}%`;

    const limitPriceDiv = document.querySelector('.fcb-progress-bar__limit-price');
    limitPriceDiv.textContent = `${formatPrice(freeShippingValue)}`;

    const titleDiv = document.querySelector('.fcb-progress-bar__title');
    const messageDiv = document.querySelector('.fcb-progress-bar__message.message-left');

    const translations = {
      es: "Te faltan {amount} para el envío gratis.",
      en: "You are {amount} away from getting free shipping.",
      fr: "Il manque {amount} pour bénéficier de la livraison gratuite.",
      de: "Es feheln dir {amount} für kostenfreien versand.",
      ca: "Et falten {amount} per a l'enviament gratuït."
    };


    const lang = htmlElement.getAttribute('lang');

    const translation = translations[lang] || translations.en;

    if (cartTotal < freeShippingValue) {
      progressBar.style.background = 'linear-gradient(105deg, #EF1F46 10.54%, #0068FF 83.12%)';
      titleDiv.style.color = 'black';
      limitPriceDiv.style.color = 'black';

      messageDiv.textContent = translation.replace('{amount}', formatPrice(freeShippingLeft));

    } else {
      progressBar.style.background = 'var(--foreground-blue, #0068FF)';
      titleDiv.style.color = 'var(--foreground-blue, #0068FF)';
      limitPriceDiv.style.color = 'var(--foreground-blue, #0068FF)';
    }


    const missingMoneyMessageDiv = document.getElementById('missingMoneyMessage');
    const freeShippingMessageDiv = document.getElementById('freeShippingMessage');

    if (cartTotal < freeShippingValue) {
      missingMoneyMessageDiv.style.display = 'block';
      freeShippingMessageDiv.style.display = 'none';
    } else {
      missingMoneyMessageDiv.style.display = 'none';
      freeShippingMessageDiv.style.display = 'block';
    }
  }

  function updateCounterUI(cartData) {
    let itemCount = 0;
    for (const item of cartData.items) {
      if (item.product_type !== "Badge" && item.product_type !== "Customization") {
        itemCount += item.quantity;
      }
    }

    const targetElement = document.querySelector('.fcb-counter');
    targetElement.setAttribute('data-items', itemCount);
  }

  document.addEventListener('click', function (event) {
    const handleQuantityUpdate = (event) => {
      const { line, quantity, name, data } = event.detail;
      checkCartUpdate(data);
    };
    document.addEventListener('quantityUpdated', handleQuantityUpdate);
    document.addEventListener('quantityUpdatedForRelatedProducts', handleQuantityUpdate);
  });

  function formatPrice(priceInCents) {
    const htmlElement = document.documentElement;
    const lang = htmlElement.getAttribute('lang');
    const country = htmlElement.getAttribute('country');
    const currency = htmlElement.getAttribute('currency');
    const currencySymbol = htmlElement.getAttribute('currency-symbol');

    const locale = `${lang}-${country}`;

    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const price = priceInCents / 100;
    const formattedPrice = formatter.format(price);

    return `${currencySymbol}${formattedPrice}`;
  }

  function checkCartUpdate(data, counter = 0) {
    updateProgressBarUI(data);
    updateCounterUI(data);
  }

  window.checkCartUpdate = checkCartUpdate;

  function fetchCartData() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        checkCartUpdate(data);
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  document.addEventListener('cartUpdated', function(event) {
    fetchCartData();
  });

  function startScript() {
    fetchCartData();
    document.addEventListener('click', handleQuantityUpdateClick);
  }

  function stopScript() {
    document.removeEventListener('click', handleQuantityUpdateClick);
  }

  function handleQuantityUpdateClick(event) {
    const handleQuantityUpdate = (event) => {
      const { line, quantity, name, data } = event.detail;
      checkCartUpdate(data);
    };
    document.addEventListener('quantityUpdated', handleQuantityUpdate);
    document.addEventListener('quantityUpdatedForRelatedProducts', handleQuantityUpdate);
  }

  function logGeActive() {
    const geactive = document.querySelector('body').getAttribute('ge-active');
    console.log("ge-active: ", geactive);
    if (geactive == 'false') {
      startScript();
    } else {
      stopScript();
    }
  }

  logGeActive();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'ge-active') {
        logGeActive();
      }
    });
  });

  const config = {
    attributes: true,
    attributeFilter: ['ge-active']
  };

  const targetNode = document.querySelector('body');
  if (targetNode) {
    observer.observe(targetNode, config);
  }
});
